import request from "@/api";

export function listShenshou(data) {
    return request({
        url: '/api/shenshou/getShenshouList',
        method: 'get',
        params: data
    })
}
export function saveShenshou(data) {
    return request({
        url: '/api/shenshou/saveShenshou',
        method: 'post',
        data: data
    })
}

export function getShenshouInfo(data) {
    return request({
        url: '/api/shenshou/getShenshouInfo',
        method: 'get',
        params: data
    })
}

export function deleteShenshou(data) {
    return request({
        url: '/api/shenshou/deleteShenshou',
        method: 'post',
        data: data
    })
}
